module.exports = __webpack_public_path__ + "img/iosTest-but.39b20f96.png";